import React from "react";
import { useAtom } from "jotai";
import { Tabs, Tab } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { selectedTabAtom, setPageAtom } from "../../atoms/bookingsTable";

export const BookingsTabs = ({ hasTodayBookings }) => {
    const [selectedTab, setSelectedTab] = useAtom(selectedTabAtom);

    const [, setPageAction] = useAtom(setPageAtom);
    const navigate = useNavigate();

    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue);
        navigate(`/new-bookings/${newValue}`);
        setPageAction(0);
    };

    return (
        <Tabs value={selectedTab} onChange={handleTabChange}>
            {hasTodayBookings && (
                <Tab label="Today" value="today" sx={{ padding: "0px" }} />
            )}
            <Tab label="Upcoming" value="upcoming" sx={{ padding: "0px" }} />
            <Tab label="Past" value="past" sx={{ padding: "0px" }} />
        </Tabs>
    );
};
